export default __webpack_public_path__ + "static/media/sliderImg2.b5c6fd15.png";